import CheckboxField from "../components/radio-butoms/radioButom";
import { FormProps, InputTypes } from "../components/textFieldProps";
import NumbersField from "../components/number-fields/numbers-field";
import MoneyField from "../components/money-fields/money-field";

export default function FormularioHistorialyRiesgo({formulario, setFormulario, editable}: {formulario : any, setFormulario : any, editable: boolean}) {

    return (
        <>
            <div className="flex-1 grid grid-cols-2 gap-4">               
                <PuntajeCentrales model={formulario} setModel={setFormulario} editable={editable}/>
                <PuntajeTruora model={formulario} setModel={setFormulario} editable={editable}/>
            </div>
            <div className="mt-8">
                <div className="flex grid grid-cols-2 gap-4 mt-4">
                    <Moras model={formulario} setModel={setFormulario}  editable={editable}/>
                    <div className="mt-9">
                        <AntiguedadMoras model={formulario} setModel={setFormulario}  editable={editable}/>
                    </div>
                    <div className="mt-4">
                        <NumeroObligaciones model={formulario} setModel={setFormulario}  editable={editable}/>
                    </div>
                </div>
            </div>
            <div className="mt-8 mb-32">
                <CuentasEmbargadas model={formulario} setModel={setFormulario} editable={editable}/> 
            </div>
        </>
    );
}

const PuntajeCentrales = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {
    
    return (
        <NumbersField
            model={formulario}
            required={true}
            setModel={setFormulario}
            campoId='score_credit_centers'
            placeholder='Puntaje en centrales'
            campoIdRespuesta='centers_score'
            title={'Puntaje en centrales de riesgo'}
            tooltip={<>Valor que arroja TransUnion desde <br></br>el proceso de Pre-aporbados</>}
            type={InputTypes.Number}
            min={150}
            max={1000}
            editable={editable}
        />
    )
}

const PuntajeTruora = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {
    
    return (
        <NumbersField
            model={formulario}
            required={true}
            setModel={setFormulario}
            campoId='truora_score'
            placeholder='Puntaje Truora'
            campoIdRespuesta='score_truora'
            title={'Puntaje Truora'}
            tooltip={<>Puntaje arrojado por Truora desde <br></br>el proceso de Pre-aporbados</>}
            type={InputTypes.Number}
            min={0}
            max={10}
            editable={editable}
        />
    )
}

const Moras = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {

    return(
        <MoneyField
            model={formulario}
            required={true}
            setModel={setFormulario}
            campoId='arrears_amount'           
            campoIdRespuesta={'score_arrears'}
            placeholder={'Valor de la mora'}
            title={'Moras'}
            tooltip={<>Retrasos que tenga el cliente en sus obligaciones actuales.<br></br>Consulta el PDF de Información comercial de TransUnion<br></br>en la sección de Resumen Endeudamiento</>}
            type={InputTypes.Money}
            min={0}
            allowZero={true}
            editable={editable}
        />

        
    )
}

const AntiguedadMoras = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {
    
    return(
        <NumbersField
            model={formulario}
            required={true}
            setModel={setFormulario}
            campoId={'arrears_oldness'}
            placeholder={'Meses de mora'}
            type={InputTypes.Number}
            min={0}
            max={6}
            editable={editable}
        />
    )
}

const NumeroObligaciones = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {
    return(
        <NumbersField
            model={formulario}
            required={true}
            setModel={setFormulario}
            campoId={'liabilities'}
            placeholder={'N° de obligaciones'}
            type={InputTypes.Number}
            min={0}
            max={20}
            editable={editable}
        />
    )
}

const CuentasEmbargadas = ({ model, setModel, editable }: FormProps) => {
    return (
        <div>
            <CheckboxField
                type={InputTypes.Boolean}
                required={true}
                model={model}
                setModel={setModel}
                campoId='seized_accounts'
                campoIdRespuesta='accounts_seized_denied'
                title={'Cuentas embargadas'}
                tooltip={<>Consulta el PDF de Información comercial de TransUnion<br></br>en la sección de Informe detallado</>}
                opcionTrue='Sí'
                opcionFalse='No'
                editable={editable}
            />
        </div>
    );
};